import {
  TSelectCsvSeperatorTranslations,
} from './select-csv-seperator.ts';

const options: TSelectCsvSeperatorTranslations = {
  comma: 'Przecinek',
  pipe: 'Rura',
  semicolon: 'Średnik',
  space: 'Przestrzeń',
  tab: 'Patka',
};

export default {
  placeholder: '',
  label: 'Separator',
  options,
};
